
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import RunnitsInfoDialog from '@/views/Runnits/RunnitInfoDialog/RunnitsInfoDialog.vue';
import ListItem from '@/components/base/ListItem.vue';
import { User } from '@run-diffusion/shared';
import { ROUTER } from '@/router/constants';
import pluralize from 'pluralize';
import { FREE_PLAN_LIMIT_CLUB_ADD_ON_NUM_RUNNITS_LIMIT } from '@/views/Runnits/constants';

export default Vue.extend({
	name: 'UpsellRunnitsPlanDialog',
	data () {
		return {
			FREE_PLAN_LIMIT_CLUB_ADD_ON_NUM_RUNNITS_LIMIT,
		};
	},
	computed: {
		...mapState([
			'upsellDialog',
			'user',
		]),
		...mapGetters([
			'displayLabels',
		]),
		isContactSalesAction () {
			return !!(
				this.upsellDialog.manageEnterprisePlan ||
				this.upsellDialog.noCompanyBudgets ||
				this.upsellDialog.noCompanyReports ||
				this.upsellDialog.noMultiTeams ||
				this.upsellDialog.noEnterpriseNsfwSettings ||
				this.upsellDialog.noTeamRoles ||
				this.upsellDialog.noSso ||
				this.upsellDialog.noPluginsApi
			);
		},
		confirmText () {
			if (this.isContactSalesAction) {
				return 'Contact Sales';
			}
			return 'Upgrade Plan';
		},
		defaultDialogOpen () {
			const shouldOpen = !!(
				this.upsellDialog.runnitIsAtNumRunnitsLimit ||
				this.upsellDialog.runnitCannotDownloadModel ||
				this.upsellDialog.manageEnterprisePlan ||
				this.upsellDialog.noCompanyBudgets ||
				this.upsellDialog.noCompanyReports ||
				this.upsellDialog.noMultiTeams ||
				this.upsellDialog.noEnterpriseNsfwSettings ||
				this.upsellDialog.noTeamRoles ||
				this.upsellDialog.noSso ||
				this.upsellDialog.noPluginsApi
			);
			return shouldOpen;
		},
		title () {
			if (this.upsellDialog.runnitIsAtNumRunnitsLimit) {
				return `Your Plan's Limit on Boards is Reached`;
			} else if (this.upsellDialog.runnitCannotDownloadModel) {
				return `Upgrade to Download Trained Models`;
			} else if (this.upsellDialog.manageEnterprisePlan) {
				return 'Manage Enterprise Plan';
			} else if (this.upsellDialog.noCompanyBudgets) {
				return 'Upgrade to Use Budgeting Features';
			} else if (this.upsellDialog.noCompanyReports) {
				return 'Upgrade to Access Advanced Reporting';
			} else if (this.upsellDialog.noMultiTeams) {
				return `Upgrade to Create New ${pluralize(this.displayLabels.team)}`;
			} else if (this.upsellDialog.noEnterpriseNsfwSettings) {
				return 'Upgrade to Customize NSFW Settings';
			} else if (this.upsellDialog.noTeamRoles) {
				return `Upgrade to Manage ${this.displayLabels.team} Roles`;
			} else if (this.upsellDialog.noSso) {
				return 'Upgrade to Enable SSO and User Provisioning';
			} else if (this.upsellDialog.noPluginsApi) {
				return 'Upgrade to Enable Plugins and API Integrations';
			}
			return null;
		},
	},
	watch: {
		user: {
			immediate: true,
			handler (newVal: User, oldVal: User) {
				if (
					newVal !== oldVal &&
					this.upsellDialog.runnitIsAtNumRunnitsLimit &&
					this._get(newVal, 'clubInfo.token.unlimitedRunnits')
				) {
					this.dialogsInput(false);
				}
			},
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		dialogsInput (val: boolean) {
			if (!val) {
				this.setUpsellDialog({});
			}
		},
		onConfirm () {
			if (this.isContactSalesAction) {
				window.open('https://rundiffusion.com/contact-sales', '_blank');
				return;
			} else {
				this.routerPush(this.$route, this.$router, { name: ROUTER.RUNNITS_SUBSCRIPTIONS });
				this.dialogsInput(false);
			}
		},
	},
	components: {
		RunnitsInfoDialog,
		ListItem,
	},
});
